import { useEffect } from 'react';

export default function useAtcui({ iconFontPath }) {
    const FONT_FACE = `
        @font-face {
            font-family: AXLcons;
            src: url('${iconFontPath}/AXLcons.eot');
            src: url('${iconFontPath}/AXLcons.eot#iefix') format("embedded-opentype"),
            url('${iconFontPath}/AXLcons.woff2') format("woff2"),
            url('${iconFontPath}/AXLcons.woff') format("woff"),
            url('${iconFontPath}/AXLcons.ttf') format("truetype"),
            url('${iconFontPath}/AXLcons.svg#AXLcons') format("svg")
        }
    `;

    useEffect(() => {
        // attach font-face defs outside the shadow dom
        const fontStyleElmt = document.createElement('link');
        fontStyleElmt.rel = 'stylesheet';
        fontStyleElmt.href = 'https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700&display=swap';
        fontStyleElmt.crossOrigin = 'anonymous';
        fontStyleElmt.key = 'render-font-5';
        document.head.appendChild(fontStyleElmt);

        const iconStyleElmt = document.createElement('style');
        iconStyleElmt.appendChild(document.createTextNode(FONT_FACE));
        document.head.appendChild(iconStyleElmt);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
